import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';

import { AssetLibraryPage } from '@/components/assets/asset-library-page';
import { CreativeAssetKind } from '@/types/generated/enums';
import { loadNamespaces } from '@/lib/i18n/i18n';

const searchSchema = z.object({
  platform: z.enum(['google', 'meta']).optional(),
  kind: z.nativeEnum(CreativeAssetKind).optional(),
  sync_status: z.enum(['rejected', 'failed', 'invalid']).optional(),
  status: z.enum(['archived']).optional(),
  q: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/assets')({
  loader: () => loadNamespaces('assets'),
  validateSearch: searchSchema,
  staticData: {
    title: 'route.assets.title',
  },
  component: AssetsLayoutRoute,
});

function AssetsLayoutRoute(): React.ReactElement {
  return (
    <>
      <AssetLibraryPage />
      <Outlet />
    </>
  );
}
